/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import dayjs, { type Dayjs } from '@/lib/dayjs';
import type { LocationsDay } from '../interface/types';

const DAY_ORDER: LocationsDay[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

/**
 * Returns the date of every day in the current Monday-to-Sunday week, resolved
 * in the store's timezone. The store hours table renders that same window, so
 * both the holiday lookup and the temporary-closure check read their dates here
 * rather than recomputing the offset separately.
 */
export function getWeekDatesByDay(storeTimezone?: string): Record<LocationsDay, Dayjs> {
  const now = storeTimezone ? dayjs().tz(storeTimezone) : dayjs();
  const currentDayOfWeek = now.day(); // 0 = Sunday

  const mondayOffset = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
  const monday = now.add(mondayOffset, 'day').startOf('day');

  return DAY_ORDER.reduce<Record<string, Dayjs>>((week, day, index) => {
    week[day] = monday.add(index, 'day');
    return week;
  }, {}) as Record<LocationsDay, Dayjs>;
}
